import { XMarkIcon } from "@heroicons/react/24/outline";
import React , {useState} from "react";
import Button from "../../../button";
import Spinner from "../../../commons/Spinner";
import ToggleButton from "../../../commons/ToggleButton";
import AdminCustomDropdown from "../../../dropdown/AdminCustomDropDown";

const DropDownFilters = ({
  setFilterActive,
  statusData,
  selectedStatus,
  setSelectedStatus,
  applyFiltered,
  loader,
  creditRenewal = 0,
  setCreditRenewal
}) => {
  const activeStatus = selectedStatus?.some(status => status.name == "Active")
  const handleToggle = () => {
    setCreditRenewal((prev) => !prev);
  };
  return (
    <div className="border border-solid border-[#EBEFF3] rounded-md p-5 w-[255px] bg-white shadow-[0px_14px_18px_0px_rgba(55,77,98,0.14)]">
      <div className="pb-3 border-b border-solid border-[#EBEFF3] sticky mb-5">
        <div className="flex items-center justify-between gap-5">
          <h5 className="text-base font-bold leading-[160%] text-customGray">
            Filter
          </h5>
          <XMarkIcon
            className="w-6 h-6 text-customGray cursor-pointer hover:text-red-500"
            onClick={() => setFilterActive(false)}
          />
        </div>
        <p className="text-sm font-normal leading-[160%] text-[#768B9F]">
          Customize your data
        </p>
      </div>
      <div className="mb-5">
        <h6 className="text-sm font-bold leading-[160%] text-[#485868] mb-[14px]">
          Status:
        </h6>
        <AdminCustomDropdown
          options={statusData?.map((data) => data)}
          classes="px-[14px] md:px-4 py-3 border border-solid border-[#EBEFF3] rounded-[10px] bg-white flex items-center justify-between w-full"
          textClasses="inline-flex w-full items-center flex-wrap text-left gap-1 text-sm md:text-base font-medium text-customGray pr-7"
          rightIconClasses="-mr-1 h-6 w-6 text-customGray font-bold"
          menuClasses="absolute left-0 z-10 mt-5 w-full origin-top rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
          selectedOption={
            selectedStatus ? [...(selectedStatus ?? statusData[0])] : []
          }
          setSelectedOption={setSelectedStatus && setSelectedStatus}
        />
      </div>
      {activeStatus && setCreditRenewal &&
      <div className="mb-5 flex gap-3">
        <h6 className="text-sm font-bold leading-[160%] text-[#485868] mb-[14px]">
        Auto Renewal:
        </h6>
      <ToggleButton isEnabled={creditRenewal} onToggle={handleToggle} />
      </div>
    }
      <Button
        title={loader ? <Spinner isLoading={loader} /> : 'Apply'}
        classes={`bg-primary text-sm font-black leading-[160%] text-white h-[42px] flex items-center justify-center rounded-md capitilize w-full ${loader && 'pointer-events-none'}`}
        onClick={applyFiltered}
        disabled={loader}
      />
    </div>
  );
};

export default DropDownFilters;
